/*
 * @Description: banner
 * @Author: wangwangwang
 * @Date: 2020-11-03 11:00:33
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-12-31 09:52:42
 */

import request from '@/utils/request'
export const queryPage = '/icps/outer/sign/outerApi/outbanner/query_banner_List'

export function saveOne(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/banner/saveone',
    method: 'post',
    data
  })
}
/**
 * @Description: 修改
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updateOne(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/banner/updateOne',
    method: 'post',
    data
  })
}

/**
 * @Description: 启用禁用
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function updateMany(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/banner/updateMany',
    method: 'post',
    data
  })
}

/**
 * @Description: 获取背景色
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getBgColor(data) {
  return request({
    url: '/icps/outer/sign/outerApi/outbanner/query_banner_color',
    method: 'post',
    data
  })
}

/**
 * @Description: 修改背景色
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function upDataBgColor(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/bannerColor/updateOne',
    method: 'post',
    data
  })
}

/* 
* 业务系统
*/
export function getBusinessList(data) {
  return request({
    url: '/base/system/business/query_page',
    method: 'post',
    data
  })
}

/* 
*  启动页保存和修改
*/
export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/appBannerStart/saveOrUpdate',
    method: 'post',
    data
  })
}

/* 
*  启动页分页
*/
export function appStartPage(data) {
  return request({
    url: '/icps/system/sign/basicsterrace/appBannerStart/queryPage',
    method: 'post',
    data
  })
}